const copyTextBtn = document.querySelectorAll('.copy-text-btn');
const copyTooltip = document.querySelectorAll('.copy-tooltip');

copyTextBtn.forEach((copyBtn) => {
  copyBtn.addEventListener('click', function () {
    let copyText = document.querySelectorAll('.copy-text');
    let rawLink = copyText[0].value;

    //check if link is valid
    if (!rawLink.startsWith('http://') && !rawLink.startsWith('https://')) {
      rawLink = 'http:' + rawLink;
    }

    try {
      let link = new URL(rawLink);

      link.searchParams.set('utm_source', 'copy+link');
      link.searchParams.set('utm_medium', 'referral');
      link.searchParams.set('utm_campaign', 'shared+article');
      link.searchParams.set(
        'utm_content',
        copyBtn.getAttribute('title').replace(/\s+/g, '+')
      );

      navigator.clipboard.writeText(link.toString());

      copyTooltip.forEach(function (item) {
        item.style.opacity = '1';
      });
      setTimeout(function () {
        copyTooltip.forEach(function (item) {
          item.style.opacity = '0';
        });
      }, 1500);
    } catch (error) {
      console.error('Error constructing URL:', error);
    }
  });

  copyBtn.addEventListener('keypress', function (event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      copyBtn.click();
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const shareBtns = document.querySelectorAll('.a2a_kit');
  const title = document.title;
  const bodyClass = document.body.className;
  const postIdMatch = bodyClass.match(/postid-(\d+)/);
  let postId = null;

  if (postIdMatch) {
    postId = postIdMatch[1];
  }

  shareBtns.forEach((div) => {
    div.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', function () {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'share',
          share_network: link.getAttribute('aria-label'),
          article_title: title,
          article_id: postId,
        });
      });
    });
  });
});
